import(/* webpackMode: "eager" */ "C:\\dev\\okmoney\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "C:\\dev\\okmoney\\node_modules\\nuqs\\dist\\adapters\\next\\app.js");
;
import(/* webpackMode: "eager" */ "C:\\dev\\okmoney\\src\\app\\globals.css");
;
import(/* webpackMode: "eager" */ "C:\\dev\\okmoney\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\lib\\\\fonts.ts\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "C:\\dev\\okmoney\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\lib\\\\fonts.ts\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "C:\\dev\\okmoney\\src\\components\\auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "C:\\dev\\okmoney\\src\\components\\footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "C:\\dev\\okmoney\\src\\components\\header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "C:\\dev\\okmoney\\src\\components\\ui\\toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "C:\\dev\\okmoney\\src\\lib\\i18n\\provider.tsx");
